import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../services/partner.service';
import { Observable } from 'rxjs/Observable';
import{UserServices} from '../services/userservices.service'
import { ApplicationService } from '../services/application.service'
@Component({
  selector: "app-pharmacy",
  templateUrl: "./pharmacy.component.html",
  styleUrls: ["./pharmacy.component.css"]
})
export class PharmacyComponent implements OnInit {
  isShow = false;
  isHide = true;
  orderItemList:any[];
  isLoginByAdmin: boolean = false;
  partnerTypeId:string=''
  //orderItemList : Observable<any>;
 statusMessage: string = "Loading data please wait...";
  constructor(private _partnerService:PartnerService,private userServices:UserServices,private _applicationService: ApplicationService) {
    this.isLoginByAdmin = _applicationService.loginUserDetails.isAdmin
    this.partnerTypeId = _applicationService.loginUserDetails.partnertypeId
  }

  ngOnInit() {
    this.getPharmacyOrder();
  }

  getPharmacyOrder() {   
    this._partnerService.getPharmacyOrder()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.orderItemList = employeeData.response.order;           
          }         
        console.log(this.orderItemList)
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }

  viewItems(data) {
    debugger
    if (data.isViewRecord) {
        data.isViewRecord = false;
    }
    else {
        data.isViewRecord = true;
    }
}
userVerfication(userDetails) {
  this.userServices.setPatientData(userDetails)
}
}
